export const VARIABLES = {
  title: '--select--',
};

export const GSC_API_PATH = 'https://accounts.google.com/gsi/client';

// file uploading

export const FILE_UPLOAD_VARIABLES = {
  nameOfFile: 'Drag and drop',
};
// Months
export const months = [
  'Jan', 'Feb', 'Mar', 'Apr',
  'May', 'June', 'July', 'Aug',
  'Sept', 'Oct', 'Nov', 'Dec'
];

// Methods

export const REQUEST = {
  GET: 'GET',
  POST: 'POST',
  PATCH: 'PATCH',
  DELETE: 'DELETE',
};

export const TABLE_VARIABLES = {
  AssetTag: 'Asset Tag',
  ticketDate: 'Ticket Date',
  assetName: 'Asset Name',
  status: 'Status',
  ticketRaisedBy: 'Ticket raised by',
};

export const BOOLEAN = {
  true: true,
  false: false,
};

export const FILTER = {
  todo: 'to-do',
  onhold: 'on-hold',
  closed: 'closed',
  all: 'all',
  ongoing: 'ongoing',
  pending: 'pending',
  assigned: 'assigned',
};

export const G_AUTH_TOKEN =
  '874163583758-u3f0rdgpdlqsirp6ajsvm61bpc2d7bh7.apps.googleusercontent.com';

export const BASIC_AUTH = {
  BASIC_AUTH: 'rECJrar6W1'
}

export const PAGINATION_DATA = [
  { title: '5', value: '5' },
  { title: '10', value: '10' },
  { title: '15', value: '15' },
];

export const PROGRESS_STATUS = {
  FAILED: 'fail',
  SUCCESS: 'success',
  NONE: 'none',
};

export const ASSET_INFO_HEADINGDS = {
  TICKET_STATUS: 'Ticket Status',
  ASSET_STATUS: 'Asset Status',
  APPROVAL_STATUS: 'Approval Status'
};

export const PROVIDER = {
  CODITAS: 'CODITAS',
  EKO_CLIENT: 'EKO CLIENT',
  LICENSES: 'LICENSES'
}

export const MODALS = {
  ASSIGNEE_CONFIRMATION_POPUP: 'assignee-confirmation-popup',
  ASSIGNEE_CONFIRMATION_POPUP_FIRST_TIME: 'assignee-confirmation-popup-for-first-time',
  CHECKOUT_CONFIRMATION_POPUP: 'checkout-confirmation-popup',
  DUPLICATE_ASSET_POPUP: 'duplicate-asset-popup',
  CHECKOUT_SUCCESS_CONFIRMATION_POPUP: 'checkout-success-confirmation-popup',
  CHECKIN_CONFIRMATION_POPUP: 'checkin-confirmation-popup',
  CHECKIN_SUCCESS_CONFIRMATION_POPUP: 'checkin-success-confirmation-popup',
  RESEND_APPROVAL_CONFIRMATION: 'resend-approval-confirmation',
  REQUEST_APPROVAL_CONFIRMATION: 'request-approval-confirmation',
  RAISE_TICKET_MODAL: 'raise-ticket-modal',
  REQUEST_ASSET_MODAL: 'request-asset-modal',
  ACCESS_INSTALLATION_MODAL: 'access-installation-modal',
  RENEW_ACCESS_MODAL: 'renew-access-modal',
  REVOKE_ACCESS_MODAL: 'revoke-access-modal',
  ADD_ASSET_COMMENT_MODAL: 'add-asset-comment-modal',
  ADD_RECOVERY_NOTE_MODAL: 'add-recovery-note-modal',
  OUT_FOR_REPAIR_MODAL: 'out-for-repair-modal',
  CHECKOUT_FOR_REPAIR_SUCCESSFULL: 'checkout-for-repair-successfull',
  REVIEW_ACCESS_REQUEST_MODAL: 'review-access-request-modal',
}

export const STORE_RUNTIME_CHECKS = {
  strictStateImmutability: true,
  strictActionImmutability: true,
  strictStateSerializability: true,
  strictActionSerializability: true,
};

export const SEARCH_FILTERS = {
  TICKET_NUMBER: 'TICKET_NUMBER',
  TICKET_DATE: 'TICKET_DATE',
  ASSET_NAME: 'ASSET_NAME',
  ASSET_TAG: 'ASSET_TAG',
  LOANEE: 'LOANEE',
  TICKET_ASSIGNED_TO: 'TICKET_ASSIGNED_TO',
  TICKET_RAISED_BY: 'TICKET_RAISED_BY',
  WORKSPACE_NAME: 'WORKSPACE_NAME',
  WORKSPACE_STATUS: 'WORKSPACE_STATUS',
  ASSIGNED_TO: 'ASSIGNED_TO',
  DEFAULT: 'DEFAULT',
  CLIENT_NAME: 'CLIENT_TIME',
  CREATED_BY: 'CREATED_BY',
  PROJECT_NAME: 'PROJECT_NAME'
} as const;

export type SearchFilter = keyof typeof SEARCH_FILTERS;

export const DEFAULT_PLACEHOLDERS = {
  TICKET_NO: 'Enter the ticket number (Eg - 2923)',
  ASSET_TAG: 'Enter the asset code (Eg - CSL-L-19-20-L-0002)'
}

export enum ROLE {
  ADMIN = 'ADMIN',
  USER = 'USER',
  SEMI_ADMIN = 'SEMI-ADMIN',
}

export function getCurrentUserRole(): string | undefined {
  return JSON.parse(localStorage.getItem('userInfo') || '{}')?.roles?.[0];
}

export function isReadOnlyRole(role: string | undefined = getCurrentUserRole()): boolean {
  return role === ROLE.SEMI_ADMIN;
}

export function hasPermission(permissionKey: string): boolean {
  const permissions = JSON.parse(localStorage.getItem('permissions') as string) as string[] | null;
  return permissions ? permissions.includes(permissionKey) : false;
}

export const MONTH_NAMES = [
  'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
  'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec',
] as const;

export const NEW_FEATURE_BADGE_VISIBILITY_DAYS = 7;

export const NEW_FEATURE_LAUNCH_DATES = {
  TOOL_ACCESS: '2026-07-31',
} as const;

export function isNewFeatureBadgeVisible(
  launchDate: string | Date,
  visibilityDays: number = NEW_FEATURE_BADGE_VISIBILITY_DAYS
): boolean {
  const expiry = new Date(launchDate);
  expiry.setDate(expiry.getDate() + visibilityDays);
  return new Date() < expiry;
}
